module.exports = __webpack_public_path__ + "static/33-125942942ebef39d20d6c895ea2fdcd3.jpg";